import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import { useTranslation } from 'react-i18next'

export default function FinishPrizes ({ race, distance }) {
  const { t } = useTranslation('raceGuide')
  // Find the specific distance object that matches the provided distance
  const distanceObj = race?.raceDistances?.find(d => d.distance === distance)
  const prizes = distanceObj?.prizes || {}

  // Filter out non-numeric keys (like 'age') and sort by position
  const sortedPrizes = Object.entries(prizes)
    .filter(([key]) => !isNaN(Number(key)))
    .sort(([a], [b]) => Number(a) - Number(b))

  // Extract special categories (like 'age')
  const specialCategories = Object.entries(prizes)
    .filter(([key]) => isNaN(Number(key)))

  return (
    <Box>
      <Typography variant='h6' component='h3'>
        {race.prizes.title}
      </Typography>
      <Typography>
        {race.prizes.description}
      </Typography>
      <Typography
        variant='h6' component='h3' sx={{
        mt: 2
      }}
      >
        {t('finishPrizes.prizesLabel')}
      </Typography>
      {sortedPrizes.length > 0 && (
        <Box>
          <List dense>
            {sortedPrizes.map(([position, prize]) => (
              <React.Fragment key={position}>
                <ListItem>
                  <ListItemText
                    primary={`${position}: ${prize}`}
                    primaryTypographyProps={{ variant: 'h6' }}
                  />
                </ListItem>
              </React.Fragment>
            ))}
          </List>
        </Box>
      )}

      {specialCategories.length > 0 && (
        <Box>
          <Typography variant='subtitle1'>
            {t('finishPrizes.specialCategories')}
          </Typography>
          <List dense>
            {specialCategories.map(([category, prize]) => (
              <React.Fragment key={category}>
                <ListItem>
                  <ListItemText
                    primary={`${category.charAt(0).toUpperCase() + category.slice(1)}: ${prize}`}
                    primaryTypographyProps={{ variant: 'body2' }}
                  />
                </ListItem>
              </React.Fragment>
            ))}
          </List>
        </Box>
      )}

      {sortedPrizes.length === 0 && specialCategories.length === 0 && (
        <Typography variant='body2'>{t('finishPrizes.noInfo')}</Typography>
      )}
    </Box>
  )
}
